import type {Optional} from '@logistics-frontend/types'
import {applySpec, flow, get, ifElse, isFilled, toNumber, toUndefined} from '@yandex-delivery/utils'

import type {PointAddress, SddCargoPointAddress} from 'src/shared/types'

export const fromPointAddressToAddress: (pointAddress: Optional<PointAddress>) => SddCargoPointAddress =
  applySpec<SddCargoPointAddress>({
    fullname: get('fullName'),
    shortname: get('shortName'),
    coordinates: get('coordinates'),
    country: get('country'),
    city: get('city'),
    building: get('building'),
    street: get('street'),
    porch: get('porch'),
    floor: flow(get('floor'), ifElse(isFilled, toNumber, toUndefined)),
    flat: flow(get('flat'), ifElse(isFilled, toNumber, toUndefined)),
    sfloor: get('floor'),
    sflat: get('flat'),
    door_code: get('doorCode'),
    comment: get('comment'),
    uri: get('uri'),
  })
